import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Button,
} from '@material-ui/core';

import BasicInfo from './BasicInfo';
import ProfileIntro from './ProfileIntro';
import PersonalInfo from './PersonalInfo';
import LifestyleInfo from './LifestyleInfo';
import EducationInfo from './EducationInfo';
import FamilyInfo from './FamilyInfo';
import ContactInfo from './ContactInfo';
import ReferenceInfo from './ReferenceInfo';
import ProfilePhotos from './ProfilePhotos';
import ProfileIdProof from "./ProfileIdProof";
import ProfilePDFs from './ProfilePDFs';
import PartnerChoice from './PartnerChoice';
import ProfileQuickSummary from './ProfileQuickSummary';
import StaffUserInfo from "./StaffUserInfo";

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';
import axios from "../../config/axios";
import { getAuthHeaders } from "../../auth/actions";


const displayProfile = (props) => {
    console.log('displayProfile===props===',props)

    const conformProfile = () => {
        const token=localStorage.getItem('token')
        console.log(token);
        axios.get('/profiles/update_status', getAuthHeaders(token))
          .then((res) => {
              console.log(res);
              props.history.push(routes.PROFILE_STATUS)
          })
          .catch((error) => {
              console.log(error);
          });
    }

  return (
    <React.Fragment>
      <ProfileIntro {...props} />
      <br />
      {(props.user.state === 2)
        ? (
          <Button variant="outlined" className={classes.dangerButton} onClick={conformProfile}>
            Conform Profile
          </Button>
        ) : null}
      <br/>
      <br/>
      <ProfilePhotos {...props} />
      <br />
      <ProfileQuickSummary {...props} />
      <br />
      {props.profile.is_editable
        ? <React.Fragment><ProfilePDFs {...props} /><br /></React.Fragment>
        : null}
      {/*{props.profile.is_editable*/}
      {/*  ? <React.Fragment><ProfileIdProof {...props} /><br /></React.Fragment>*/}
      {/*  : null}*/}
      {props.profile.is_editable
        ? <React.Fragment><BasicInfo {...props} /><br /></React.Fragment>
        : null}
      <PersonalInfo {...props} />
      <br />
      {/*<LifestyleInfo {...props} />*/}
      {/*<br />*/}
      <EducationInfo {...props} />
      <br />
      <FamilyInfo {...props} />
      <br />
      {/* <ContactInfo {...props} /> */}
      {/* <br /> */}
      {props.profile.is_editable
        ? <React.Fragment><ReferenceInfo {...props} /><br /></React.Fragment>
        : null}
      {props.profile.partnerchoice
        ? <PartnerChoice {...props} /> : null}
      <br />
      {props.profile.admin_email
        ? <StaffUserInfo {...props} /> : null}
      <br />
      {props.profile.is_editable
        ? (
          <Link
            to={formatRoute(routes.DELETE_PROFILE)}
            className={classes.linkDeCSS}
          >
            <Button variant="outlined" className={classes.dangerButton}>Delete Profile</Button>
          </Link>
        ) : null}
      {/*{(props.user.state === 2)*/}
      {/*  ? (*/}
      {/*    <Button variant="outlined" className={classes.dangerButton} onClick={conformProfile} style={{ marginLeft: '10px'}}>*/}
      {/*      Conform Profile*/}
      {/*    </Button>*/}
      {/*  ) : null}*/}
    </React.Fragment>
  );
};

export default displayProfile;



// WEBPACK FOOTER //
// ./src/profile/components/DisplayProfile.js